"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Save = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 22,
  height: 23,
  viewBox: "0 0 22 23",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.9458 0.833374H8.27913V4.83337H10.9458V0.833374ZM4.27913 0.833415H2.94572C1.47296 0.833415 0.279053 2.02732 0.279053 3.50008V19.5001C0.279053 20.9728 1.47296 22.1667 2.94572 22.1667H18.9457C20.4185 22.1667 21.6124 20.9728 21.6124 19.5001V7.27132C21.6124 6.56407 21.3314 5.8858 20.8313 5.3857L17.0601 1.61446C16.56 1.11437 15.8817 0.833415 15.1745 0.833415H12.2791V4.83337C12.2791 5.56975 11.6822 6.16671 10.9458 6.16671H5.61247C4.87609 6.16671 4.27913 5.56975 4.27913 4.83337V0.833415ZM4.27913 15.5C4.27913 14.0273 5.47304 12.8334 6.9458 12.8334H14.9458C16.4186 12.8334 17.6125 14.0273 17.6125 15.5V19.5C17.6125 20.2364 17.0155 20.8334 16.2791 20.8334H5.61247C4.87609 20.8334 4.27913 20.2364 4.27913 19.5V15.5ZM6.9458 16.8334C6.9458 16.097 7.54275 15.5 8.27913 15.5H13.6125C14.3488 15.5 14.9458 16.097 14.9458 16.8334C14.9458 17.5698 14.3488 18.1667 13.6125 18.1667H8.27913C7.54275 18.1667 6.9458 17.5698 6.9458 16.8334Z",
  className: "fill"
}));
var _default = exports.default = Save;